<template>
    <div class="main_container">
        <div id="background"
            :class="{ 'detail_background': selectedMessage !== null || showMessageForm || showMessageDetail }">
            <div v-if="selectedMessage === null && !showMessageForm && !showMessageDetail">
                <!-- 기존 메시지 리스트 -->
                <div class="category_container">
                    <div class="category_item" style="flex: 6;">제목</div>
                    <div class="category_item" style="flex: 2;">작성자</div>
                    <div class="category_item" style="flex: 2;">작성일</div>
                </div>
                <div v-for="message in displayedMessages" :key="message.idx" class="message_item"
                    @click="showMessageDetails(message)">
                    <div class="message_info">
                        <label :style="{ color: message.subject ? 'white' : 'transparent' }">
                            {{ message.subject ? (message.orders == 0 ? '●&nbsp;' : '&nbsp;┖▶&nbsp;') : '' }}
                            {{ message.orders == 0 ? message.subject : message.content }}
                        </label>
                    </div>
                    <div class="message_sender">
                        <label :style="{ color: message.type != null ? 'white' : 'transparent' }">{{ message.type === 0
                            ? '본인' : (message.type === 1 ? '운영자' : '') }}</label>
                    </div>
                    <div class="message_date" :style="{ color: message.send_time ? 'white' : 'transparent' }">{{
                        formatDate(message.send_time) || '' }}</div>
                </div>
                <!-- 페이지네이션 -->
                <div class="pagination" v-if="this.selectedMessage === null && !showMessageForm && !showMessageDetail">
                    <div class="page_btn_container" style="width: 92px;">
                        <button @click="prevPage" :disabled="currentPage === 1" class="button"
                            v-show="currentPage !== 1">이전</button>
                    </div>
                    <span class="page_number" style="width: 60px;">{{ currentPage }} / {{ totalPages }}</span>
                    <div class="page_btn_container" style="width: 92px;">
                        <button @click="nextPage" :disabled="currentPage === totalPages" class="button"
                            v-show="currentPage !== totalPages">다음</button>
                    </div>
                </div>
                <button @click="showMessageForm = true, this.replyMessage = null" class="msg_btn" v-if="!showMessageDetail">새 문의 작성</button>
            </div>
            <div v-else-if="showMessageDetail">
                <!-- 메시지 상세 보기 -->
                <div class="detail_info">
                    <div class="detail_title">
                        <h3>{{ this.selectedMessage.subject }}</h3>
                        <p class="detail_date">{{ formatDate(this.selectedMessage.send_time) }}</p>
                    </div>
                    <div class="detail_content">
                        <p>{{ this.selectedMessage.content }}</p>
                        <!-- 메시지 발신자가 본인이 아닌 경우에만 답장 버튼 표시 -->
                        <button v-if="this.selectedMessage.type !== 0" @click="reply" class="send_button">추가 문의</button>
                        <span class="button_space"></span> <!-- 여백 추가 -->
                        <button v-if="selectedMessage.type === 0 && selectedMessage.orders === 0" @click="deleteMessage" class="close_button">삭제</button>
                        <span class="button_space"></span> <!-- 여백 추가 -->
                        <button @click="closeMessageDetails" class="button">닫기</button>
                    </div>
                </div>
            </div>
            <div v-else>
                <!-- 메시지 작성 폼 -->
                <message-form v-if="showMessageForm" @message-sent="fetchMessages" @close-form="closeMessageForm" :reply_msg = "this.replyMessage != null ? this.replyMessage.groupno : ''" />
            </div>

            <!-- 메시지 작성 폼 토글 버튼 -->

        </div>
    </div>
</template>

<script>
import store from '../../js/store.js';
import MessageForm from './MessageForm.vue'; // 메시지 작성 폼 컴포넌트 추가
import API from '@/components/js/API';
import Swal from "sweetalert2";

export default {
    name: "message_board",
    components: {
        MessageForm // 등록한 컴포넌트 등록
    },
    data() {
        return {
            total: 0,
            messages: [],
            currentPage: 1,
            pageSize: 10,
            selectedMessage: null,
            replyMessage: null,
            showMessageForm: false, // 메시지 폼 표시 여부
            showMessageDetail: false, // 메시지 상세 보기 여부
            form: {}
        };
    },
    computed: {
        totalPages() {
            let total = Math.ceil(this.total / this.pageSize);
            return Math.max(total, 1); // 최소값을 1로 설정
        },
        displayedMessages() {
            //const start = (this.currentPage - 1) * this.pageSize;
            //let end = start + this.pageSize;

            return this.messages.slice(0, this.pageSize);
        }
    },
    mounted() {
        // 페이지 로드 시 메시지 받아오기
        this.fetchMessages();
    },
    methods: {
        formatDate(dateString) {
            const date = new Date(dateString);
            if (date.toString() === 'Invalid Date') 
            {
                return '';
            }
            else
            {
                return `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate()}`;
            }
        },
        prevPage() {
            if (this.currentPage > 1) {
                this.currentPage--;
                this.fetchMessages();
            }
        },
        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.currentPage++;
                this.fetchMessages();
            }
        },
        showMessageDetails(message) {
            if (message.subject && message.send_time) {
                // 메시지 상세 보기 표시
                this.replyMessage = null;
                this.selectedMessage = message;
                this.showMessageDetail = true;
            }
        },
        closeMessageDetails() {
            // 메시지 상세 보기 닫기
            this.replyMessage = null;
            this.selectedMessage = null;
            this.showMessageDetail = false;
        },
        fetchMessages() {
            this.form = {
                user_id: store.state.user.id,
                page: this.currentPage-1,
                page_num: this.pageSize
            };
            API.AxiosPost('qna/getQnaUser', this.form, true,
                response => {
                    this.messages = Array.isArray(response.data.data.data) ? response.data.data.data : []; // 배열로 변환하여 할당
                    this.total = response.data.data.total;
                    // 부족한 만큼 빈 아이템 추가
                    // console.log("Response.data");
                    // console.log(response.data.data.data);
                    // const emptyItemCount = this.pageSize - this.messages.length;
                    // for (let i = 0; i < emptyItemCount; i++) {
                    //     this.messages.push({ idx: null, subject: '', content: '', send_time: '', type: -1 });
                    // }
                }
            )
        },
        closeMessageForm() {
            this.selectedMessage = null;
            this.showMessageForm = false; // 메시지 폼 닫기
        },
        reply() {
            this.replyMessage = this.selectedMessage;
            console.log(this.replyMessage);
            this.showMessageDetail = false;
            this.showMessageForm = true;
        },
        deleteMessage() {
            Swal.fire({
                title: '삭제 확인',
                icon: 'warning',
                html: '해당 문의와 관련된 답변 및 추가 문의도 모두 삭제되며<br>삭제된 내용들은 복구할 수 없습니다.<br>삭제하시겠습니까?',
                showCancelButton: true,
                confirmButtonText: '확인',
                cancelButtonText: '취소'
            }).then(() => {
                const form = {
                    groupno: this.selectedMessage.groupno.toString()
                }
                API.AxiosPost('qna/deleteQna', form, true,
                    (res) => {
                        if (res.status == 200) {
                            switch (res.data.code) {
                                case '200':
                                    API.showToast('success', '문의 삭제 완료');
                                    break;
                                default:
                                    // 다른 응답 코드 처리
                                    break;
                            }
                            this.closeMessageDetails();
                            this.fetchMessages();
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                html: '처리과정에 문제가 발생했습니다.<br>해당 현상 반복시 문의바랍니다.',
                            });
                            console.log("return status : " + res.status);
                        }
                    }
                )
            });
        }
    }
};
</script>


<style>
.message_info {
    float: left;
    width: 60%;
    flex: 6 !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    text-align: left;
    padding-left: 10px;
}
.message_sender {
    float: left;
    width: 20%;
    flex: 2 !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.message_date {
    width: 20%;
    flex: 2 !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.message_info h3 {
    font-size: 18px; /* 원하는 폰트 크기로 조정하세요 */
}

.message_date {
    font-size: 16px; /* 원하는 폰트 크기로 조정하세요 */
}
.category_container{
    margin-left: 10px;
    margin-right: 10px;
}
.message_item {
    height: 25px;
    margin-left: 10px;
    margin-right: 10px;
    border-bottom: 1px solid #adadadc4;
    /* 구분선 스타일링 */
}
.msg_btn{
    height: 40px;
    width: 250px;
    border: 1px;
    border-radius: 20px 20px 20px 20px / 20px 20px 20px 20px;
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #2d88ff;
    color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
.detail_title h3 {
    font-size: 18px;
    margin-bottom: 5px;
    color: white; /* 제목 폰트 색상 추가 */
}

.detail_date {
    font-size: 16px;
}

.detail_content p {
    font-size: 18px;
    line-height: 3;
    color: white;
}

.button_space {
    margin-right: 10px; /* 버튼 사이의 간격 조정 */
}
.send_button,
.close_button {
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.send_button {
    background-color: #4CAF50;
    color: white;
}

.close_button {
    background-color: #f44336;
    color: white;
}
</style>@/components/js/API.js